'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import FeaturesShowcase from './FeaturesShowcase';
import AppScreenshots from './AppScreenshots';
import SystemRequirements from './SystemRequirements';
import UserTestimonials from './UserTestimonials';
import QRCodeSection from './QRCodeSection';
import SecurityPrivacy from './SecurityPrivacy';
import CTASection from './CTASection';
import Footer from './Footer';

export default function AppDownloadInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<'android' | 'ios' | null>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleDownloadClick = (platform: 'android' | 'ios') => {
    if (!isHydrated) return;

    setSelectedPlatform(platform);
    setShowDownloadModal(true);

    setTimeout(() => {
      setShowDownloadModal(false);
      setSelectedPlatform(null);
    }, 3000);
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-screen bg-muted" />
        </div>
      </div>
    );
  }

  return (
    <>
      <HeroSection onDownloadClick={handleDownloadClick} />
      <FeaturesShowcase />
      <AppScreenshots />
      <SystemRequirements />
      <UserTestimonials />
      <QRCodeSection />
      <SecurityPrivacy />
      <CTASection onDownloadClick={handleDownloadClick} />
      <Footer />

      {showDownloadModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
          <div className="bg-card p-8 rounded-2xl shadow-warm-2xl max-w-md mx-4 text-center">
            <div className="w-16 h-16 bg-success/10 text-success rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-2xl font-heading font-bold text-text-primary mb-2">
              Redirecting to {selectedPlatform === 'android' ? 'Google Play' : 'App Store'}
            </h3>
            <p className="text-text-secondary">
              Your download will begin shortly...
            </p>
          </div>
        </div>
      )}
    </>
  );
}